
import { useState } from 'react';
import Button from '../base/Button';
import SearchBox from '../base/SearchBox';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    if (sectionId === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-blue-500/95 backdrop-blur-sm border-b border-blue-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <h1 
              className="text-2xl font-light tracking-wider text-white cursor-pointer"
              onClick={() => scrollToSection('home')}
            >
              POCKET
              <span className="block text-xs bg-gradient-to-r from-pink-200 via-blue-200 to-teal-200 bg-clip-text text-transparent font-normal">
                WONDERS
              </span>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a 
              onClick={() => scrollToSection('home')}
              className="text-white hover:text-pink-200 font-light tracking-wide transition-colors cursor-pointer"
            >
              首页
            </a>
            <a 
              onClick={() => scrollToSection('featured-gems')}
              className="text-white hover:text-blue-200 font-light tracking-wide transition-colors cursor-pointer"
            >
              宝石
            </a>
            <a 
              onClick={() => scrollToSection('hot-jewelry')}
              className="text-white hover:text-teal-200 font-light tracking-wide transition-colors cursor-pointer"
            >
              首饰
            </a>
            <a 
              onClick={() => scrollToSection('gallery-showcase')}
              className="text-white hover:text-pink-200 font-light tracking-wide transition-colors cursor-pointer"
            >
              首饰定制
            </a>
            <a 
              onClick={() => scrollToSection('brand-intro')}
              className="text-white hover:text-blue-200 font-light tracking-wide transition-colors cursor-pointer"
            >
              联系我们
            </a>
          </nav>

          {/* Desktop Action Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <button className="w-10 h-10 flex items-center justify-center text-white hover:text-pink-200 transition-colors cursor-pointer">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-search-line"></i>
              </div>
            </button>
            <button className="w-10 h-10 flex items-center justify-center text-white hover:text-blue-200 transition-colors cursor-pointer">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-heart-line"></i>
              </div>
            </button>
            <button className="w-10 h-10 flex items-center justify-center text-white hover:text-teal-200 transition-colors cursor-pointer">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shopping-bag-line"></i>
              </div>
            </button>
            <Button 
              variant="gradient" 
              size="sm"
              className="rounded-full"
            >
              探索珍藏
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={isMenuOpen ? "ri-close-line" : "ri-menu-line"}></i>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-blue-600/95 backdrop-blur-sm border-t border-blue-300 py-4">
            <nav className="flex flex-col space-y-4">
              <a 
                onClick={() => scrollToSection('home')}
                className="text-white hover:text-pink-200 font-light tracking-wide transition-colors cursor-pointer px-4"
              >
                首页
              </a>
              <a 
                onClick={() => scrollToSection('featured-gems')}
                className="text-white hover:text-blue-200 font-light tracking-wide transition-colors cursor-pointer px-4"
              >
                宝石
              </a>
              <a 
                onClick={() => scrollToSection('hot-jewelry')}
                className="text-white hover:text-teal-200 font-light tracking-wide transition-colors cursor-pointer px-4"
              >
                首饰
              </a>
              <a 
                onClick={() => scrollToSection('gallery-showcase')}
                className="text-white hover:text-pink-200 font-light tracking-wide transition-colors cursor-pointer px-4"
              >
                首饰定制
              </a>
              <a 
                onClick={() => scrollToSection('brand-intro')}
                className="text-white hover:text-blue-200 font-light tracking-wide transition-colors cursor-pointer px-4"
              >
                联系我们
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
